<!--
    课程分享-新增课程
    作用：新增课包信息
    说明：版本3.0
-->
<template>
  <div
    v-loading="loading"
    :element-loading-text="loadingTxt"
    class="page-content">
    <el-scrollbar
      wrap-style="overflow-x:hidden;"
      style="height:100%">
      <div class="add-page">
        <el-form
          ref="dataForm"
          :model="form"
          :rules="rules"
          size="medium"
          label-width="130px">
          <el-form-item
            label="课程封面："
            prop="cover">
            <el-input
              v-model="form.cover"
              style="display:none"/>
            <div class="update-cover">
              <div
                v-for="(item, index) in coverImgs"
                :key="index"
                class="item item-cover">
                <div
                  v-if="item.src"
                  class="item-demo">
                  <div
                    class="del-btn"
                    @click="delCoverImage(index)">删 除</div>
                  <div class="replace-btn">
                    <el-upload
                      :multiple="true"
                      :show-file-list="false"
                      :http-request="upFile"
                      :on-change="upImg"
                      action="#"
                      accept="image/jpeg,image/png,image/jpg"
                    >
                      替 换
                    </el-upload>
                  </div>
                  <img
                    :src="item.src"
                    class="item-img">
                </div>
                <span v-else>上传中...</span>
              </div>
              <el-upload
                v-if="!coverImgs.length"
                :class="coverImgs.length>0&&'disabled'"
                :limit="1"
                :multiple="true"
                :show-file-list="false"
                :http-request="upFile"
                :on-change="upImg"
                :disabled="coverImgs.length>0"
                action="#"
                class="item update-btn"
                accept="image/*"
              >
                <i class="el-icon-plus"/>
                <span>上传图片</span>
              </el-upload>
            </div>
          </el-form-item>

          <el-form-item
            label="课程名称："
            prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入名称"
              clearable
              maxlength="80"
              @change="form.name = form.name.trim()"/>
          </el-form-item>

          <el-form-item
            label="课程简介："
            prop="introduction">
            <el-input
              v-model="form.introduction"
              placeholder="请输入简介"
              clearable
              maxlength="200"
              @change="form.introduction = form.introduction.trim()"/>
          </el-form-item>

          <el-form-item
            label="课程详细说明："
            prop="detail">
            <!-- <el-input
              :rows="6"
              v-model="form.detail"
              type="textarea"
              placeholder="请输入简介"
              maxlength="800"
              show-word-limit
              @change="form.detail = form.detail.trim()"/> -->
            <el-input
              v-model="form.detail"
              style="display:none"
            />
            <AppTextArea
              :value="form.detail"
              :init-visible="formDialogVisible"
              :is-disable="false"
              :menus="editMenus"
              :show-video="false"
              @change="changeFn"
            />
          </el-form-item>

          <el-form-item
            label="课程类别："
            prop="stage_tag_id">
            <div class="grad-select">
              <el-select
                v-model="form.stage_tag_id"
                class="item"
                style="margin-right: 15px;"
                placeholder="请选择年级"
                clearable
              >
                <el-option
                  v-for="item in gradeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-form-item
                class="item"
                prop="subject_tag_id">
                <el-select
                  v-model="form.subject_tag_id"
                  placeholder="请选择科目"
                  style="width:100%"
                  clearable
                >
                  <el-option
                    v-for="item in subjectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
          <!--
      <el-form-item label="开放校区：" prop="school">
        <el-button class="edit-btn" type="primary" plain>编辑</el-button>
        <span class="edit-tip">（当前已选择5个校区）</span>
      </el-form-item>

      <el-form-item label="课程价格：" prop="priceType">
          <el-select
            style="width:100%"
            v-model="form.priceType"
            placeholder="请选择价格类型"
            clearable
            @change="changePriceType"
          >
            <el-option
              v-for="item in priceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
      </el-form-item>

       <el-form-item label="每次课优惠价（元）" label-width="150px" style="margin-left:120px" class="price-input" prop="price">
           <el-input v-model="form.price" placeholder="请输入价格" clearable maxlength="30" @change="form.price = form.price.trim()"></el-input>
      </el-form-item>
       <el-form-item label="每次课原价（元）" label-width="150px" style="margin-left:120px" class="price-input" prop="defaultPrice">
         <el-input v-model="form.defaultPrice" placeholder="请输入价格" clearable maxlength="30" @change="form.defaultPrice = form.defaultPrice.trim()"></el-input>
      </el-form-item> -->
          <el-form-item>
            <el-radio
              v-model="form.sale_status"
              :label="2">手动上架</el-radio>
            <el-radio
              v-model="form.sale_status"
              :label="1">自动上架</el-radio>
          </el-form-item>
        </el-form>
        <div class="bottom">
          <el-button @click="handlerClose">取 消</el-button>
          <el-button
            v-if="!$route.query.packetId"
            type="primary"
            @click="handlerCreate()">新 增</el-button>
          <el-button
            v-else
            type="primary"
            @click="handlerUpdate()">修 改</el-button>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import addCourse from './addCourse';

export default addCourse;
</script>
<style scoped lang="scss">
@import "addCourse.scss"
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/addCourse/index.vue